import { createContext, useContext, ReactNode } from 'react';
import { makeAutoObservable } from 'mobx';

type LanguageState = {
  language: string;
  setLanguage: (lang: string) => void;
};

export const languageState = makeAutoObservable({
  language: 'de',
  setLanguage(lang: string) {
    this.language = lang;
  },
});

const LanguageContext = createContext<LanguageState | null>(null);

export function useLanguage(): LanguageState {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}

export function LanguageProvider({ children }: { children: ReactNode }) {
  return <LanguageContext.Provider value={languageState}>{children}</LanguageContext.Provider>;
}
